/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZD0iTTExLjQ0IDMuNDRMOSAxTDYuMDYgMy45NEw5IDYuODhMMTEuNDQgNC40NEgxNFYxNC40NEg0LjVWOC40NEg3TDQgNS40NEwxIDguNDRIMy41VjE1LjQ0SDE1VjMuNDRIMTEuNDRaTTkgNS40N0w3LjQ3IDMuOTRMOSAyLjQxTDEwLjUzIDMuOTRMOSA1LjQ3WiIgZmlsbD0iaW5oZXJpdCIvPg==";